import { TextField as MuiTextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChangeEvent } from 'react';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import { isValidNumberInput } from '../../utils/utils';
import type { FieldComponentProps } from '../form-engine/types';

type SpecialArrayItem = { name: string; label?: string; type?: string; size?: number; required?: boolean };

const SpecialArrayField = ({ field }: FieldComponentProps) => {
  const { getFormDataItem, handleSpecialArrayFieldChange } = useFormContext();
  const formData = useFormData();

  const handleItemChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, item: SpecialArrayItem, index: number) => {
    const value = e.target.value;

    if (item.type === 'number') {
      if (isValidNumberInput(value)) {
        handleSpecialArrayFieldChange(e, field as Parameters<typeof handleSpecialArrayFieldChange>[1], index);
      }
    } else {
      handleSpecialArrayFieldChange(e, field as Parameters<typeof handleSpecialArrayFieldChange>[1], index);
    }
  };

  return (
    <Grid size={field.size || 12} key={field.name}>
      <Typography color="text.primary" variant={field.font_size || 'h6'} sx={{ mb: 1 }}>
        {field.label}
      </Typography>
      <Grid container spacing={2} size={12} key={field.name + 'x'}>
        {(field.items as SpecialArrayItem[]).map((item, index) => (
          <Grid size={item.size || 12} key={item.name}>
            <MuiTextField
              label={item.label}
              fullWidth
              required={item.required || false}
              disabled={Object.prototype.hasOwnProperty.call(field, 'disabled') ? !!getFormDataItem(formData, field.disabled!) : false}
              type="text"
              name={item.name}
              value={getFormDataItem<unknown[]>(formData, field.name!)[index] ?? ''}
              onChange={(e) => handleItemChange(e, item, index)}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default SpecialArrayField;
